export class EquipmentRequestCreateUpdateDto {
  copies: number;
  equipmentRequestDetailId: string;
  equipmentTypeId: string;
  /** Per-unit in-system asset (Equipment FK); resolved as EquipmentIDs[0] of the picked group (#30640). */
  equipmentId: string | null;
  /** Per-unit Alt Id, unique among the request's active units (#30640). */
  altId: string | null;

  supervisor: string;
  supervisorId: string;

  jobId: string;
  startDate: Date;
  endDate: Date;
  equipmentDispatchStatusId: string;
  notes: string;
  previousNotes: string;

  isBillable: string;
  phaseId: string;
  phaseName: string;
  poNumber: string;
  timeNeeded: string;
}
